<template>
    <div>
        <common-content-spacer height="tiny">
            <offer-results v-if="companyOffers.length" :companyOffers="companyOffers" :isCompanyPublicPage="true"></offer-results>
            <div v-else>
                {{ $t('pages.offer.find_offers.no_offers') }}
            </div>
        </common-content-spacer>
    </div>
</template>

<script>
    import OfferResults from 'components/page-elements/offer/OfferResults'

    export default {
        components: { OfferResults },
        props: {
            companyOffers: { type: Object, default: undefined },
        },
    }
</script>
